import { RestService } from '../_servicos/rest.service';
import { LogAcessoSistema } from './log-acesso-sistema';

export class UtilLogAcessoSistema {
  static registrarAcessoAoRecurso(
    recurso: string,
    idServidor: number,
    service: RestService
  ) {
    let x: LogAcessoSistema = new LogAcessoSistema();

    x.dhAcesso = new Date();
    x.dsRecurso = recurso;
    x.fkSistema = 57;
    x.fkServidor = idServidor;
    //console.log('vou registrar log de acesso ao sistema');
    //console.log(x);
    service.setLogAcessoSistema(x).subscribe();
  }
}
